/**
 * UnscheduleEventModal
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import RoleGate from '../../../../../../components/RoleGate';

// Actions
import { updateQueryString } from '../../../../../../services/router/actions';

// Components
// @ts-ignore
import ErrorBoundaryAlert from '../../../../../../components/ErrorBoundaryAlert';
import UnscheduleEventForm from './components/UnscheduleEventForm';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from '../../../../../../workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from '../../../../../../workspaces/react-router-selectors';

interface ConnectedProps {
    selectedEvent: number;
    unscheduleEventModal: boolean;
}
interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class UnscheduleEventModal extends React.PureComponent<Props> {
    get open(): boolean {
        const { unscheduleEventModal, selectedEvent } = this.props;
        return !!unscheduleEventModal && !!selectedEvent;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            unscheduleEventModal: undefined,
            selectedEvent: undefined
        });
    };

    render(): React.ReactElement {
        const { selectedEvent } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="UnscheduleEventModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Unschedule</Modal.Header>
                        <Modal.Content>
                            <p>Are you sure you want to unschedule this job?</p>
                            <UnscheduleEventForm
                                harvestEventUuid={selectedEvent}
                                onClose={this.handleClose}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    selectedEvent: makeSelectQueryStringValue('selectedEvent'),
    unscheduleEventModal: makeSelectQueryStringValue('unscheduleEventModal')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(UnscheduleEventModal);
